import React, { useState, useCallback } from 'react';
import { LinkIcon, CheckCircleIcon, PencilSquareIcon } from '@heroicons/react/24/outline';

export default function CopyLinkButton({ campaignId, slug, utmSource = 'share', className = '', onEditSlug }) {
  const [copied, setCopied] = useState(false);

  const token = slug || campaignId;
  const url = `${window.location.origin}/p/${token}`;
  const host = (() => {
    try { return new URL(url).host.replace(/^www\./, ''); } catch { return ''; }
  })();
  const editLabel = slug ? 'Edit custom link' : 'Set custom link';

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      console.error('Failed to copy link:', e);
    }
  }, [url]);

  return (
    <div className={`w-full flex items-stretch overflow-hidden rounded-lg gch-input-ghost transition-colors ${className}`}>
      <button
        type="button"
        onClick={handleCopy}
        title={url}
        className="min-w-0 flex-1 flex items-center gap-2 p-2.5 text-left hover:bg-white/10 transition-colors group"
      >
        <span className="text-xs truncate flex-1">
          <span className="gch-text-muted">{host}</span>
          <span className="gch-text-primary font-medium">/p/{token}</span>
        </span>
        {copied ? (
          <CheckCircleIcon className="w-4 h-4 text-green-500 shrink-0" />
        ) : (
          <LinkIcon className="w-4 h-4 gch-text-secondary group-hover:gch-text-primary shrink-0" />
        )}
      </button>
      {onEditSlug && (
        <button
          type="button"
          onClick={onEditSlug}
          className="w-10 shrink-0 border-l border-[var(--admin-border)] gch-text-secondary hover:gch-text-primary hover:bg-white/10 transition-colors inline-flex items-center justify-center"
          title={editLabel}
          aria-label={editLabel}
        >
          <PencilSquareIcon className="w-4 h-4" aria-hidden />
        </button>
      )}
    </div>
  );
}
